import { LOCAL_STORAGE_PRE_QUOTE_KEY } from './featureFlags'
import { FeatureFlagPreQuoteOverrideArgs, MapFeatureFlagsArgs } from './featureFlags.types'

import { getLocalStorageItem } from 'utils/localStorage'

// LOCAL STORAGE
export const setPreQuotePersistentFeatureFlags = ({
  quoteId,
  flagName,
  value,
}: FeatureFlagPreQuoteOverrideArgs) => {
  const preQuoteOverrideKey = getPreQuoteOverrideKey(quoteId)
  const preQuotePersistentFlags = getLocalStorageItem(preQuoteOverrideKey)

  if (preQuotePersistentFlags === null) {
    localStorage.setItem(preQuoteOverrideKey, JSON.stringify({ [flagName]: value }))
    return
  }

  localStorage.setItem(
    preQuoteOverrideKey,
    JSON.stringify({ ...preQuotePersistentFlags, [flagName]: value }),
  )
}

export const resetPreQuotePersistentFeatureFlags = (quoteId: string) => {
  const preQuoteOverrideKey = getPreQuoteOverrideKey(quoteId)
  localStorage.removeItem(preQuoteOverrideKey)
}

export const getPreQuoteOverrideKey = (quoteId: string) =>
  `${quoteId}_${LOCAL_STORAGE_PRE_QUOTE_KEY}`

export const overrideFeatureFlags = <T extends string>(
  initialFeatureFlags: { [key in T]: boolean },
  defaultfeatureFlagKeys: T[],
  featureFlagsOverrides: Partial<{ [key in string]: boolean }>,
) => {
  return defaultfeatureFlagKeys.reduce(
    (accumulator, key) => {
      const overrideValue = featureFlagsOverrides[key]

      const shouldOverrideValue = overrideValue !== undefined

      accumulator[key] = shouldOverrideValue ? overrideValue : initialFeatureFlags[key]

      return accumulator
    },
    {} as Record<T, boolean>,
  )
}

export const mapFeatureFlags = <T extends string>({
  featureFlagsData,
  defaultFlags,
  isSuccess,
}: MapFeatureFlagsArgs<T>) => {
  const flagKeys = Object.keys(defaultFlags) as T[]

  const featureFlags =
    isSuccess && featureFlagsData
      ? flagKeys.reduce<Record<T, boolean>>(
          (accumulator, key) => {
            accumulator[key] = featureFlagsData[key].active

            return accumulator
          },
          {} as Record<T, boolean>,
        )
      : defaultFlags

  return featureFlags
}
